import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const polarisSettingsAccessRoute: InvariantJiraRoute = {
	name: 'polaris-settings-access',
	path: '/jira/settings/products/jira-product-discovery/access',
	exact: true,
};
